import { motion } from "framer-motion";
import Reveal from "./Reveal";
import MaskedLines from "./MaskedLines";

export default function CtaSection({ t, waLink }) {
  const c = t.cta;
  return (
    <section
      id="contact"
      className="relative overflow-hidden py-28 md:py-40 border-t border-[var(--border)] bg-[#080808]"
    >
      {/* Background giant italic text */}
      <div
        aria-hidden
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
      >
        <span className="font-serif-italic text-[38vw] leading-none text-[#0f0f0f]">
          Hi.
        </span>
      </div>

      <div className="container-x relative z-10">
        <Reveal>
          <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display">
            <span className="w-6 h-[1px] bg-[var(--accent)]" />
            {c.overline}
          </div>
        </Reveal>

        <div className="mt-6 md:mt-8">
          <MaskedLines
            className="font-display font-black uppercase leading-[0.92] tracking-tighter text-[13vw] md:text-[9vw] lg:text-[8vw] text-[var(--text)]"
            as="h2"
            stagger={0.1}
            delay={0.15}
            lines={[
              <span key="c1">
                {c.line1}{" "}
                <span className="font-serif-italic text-[var(--accent)] font-normal normal-case tracking-normal">
                  {c.line1Italic}
                </span>
              </span>,
              <span key="c2">
                {c.line2}{" "}
                <span className="font-serif-italic text-[var(--text)] font-normal normal-case tracking-normal">
                  {c.line2Italic}
                </span>
              </span>,
            ]}
          />
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-12 gap-6 md:gap-8 items-end">
          <Reveal delay={0.2} className="col-span-12 md:col-span-6">
            <p className="text-[var(--text-muted)] text-base md:text-lg leading-relaxed max-w-md">
              {c.body}
            </p>
          </Reveal>
          <Reveal delay={0.3} className="col-span-12 md:col-span-6 flex md:justify-end">
            <motion.a
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp-main"
              className="inline-flex items-center gap-4 px-8 py-6 rounded-full bg-[var(--accent)] text-[var(--bg)] font-display uppercase tracking-widest text-sm md:text-base hover:bg-[var(--text)] transition-colors"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
                aria-hidden
              >
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.223 8.223 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.85-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.4-.12-.56.12-.17.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01"/>
              </svg>
              {c.button}
              <span aria-hidden className="text-2xl">↗</span>
            </motion.a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
